import { jsNode } from '@shared/node-v1.0.0'

import v010 from '@nodes/node-v0.1.0'

export default jsNode('node', {
	'v0.1.0': v010,
})
